<template>
  <div class='home'>
    <StateList
      v-show='listView'
      @newState='onClickNewFromList'
      @editState='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <StateForm
      v-show='formView'
      :state='state'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import StateList from '@/components/state/StateList.vue'
import StateForm from '@/components/state/StateForm.vue'

export default {
  name: 'State',
  components: {
    StateList,
    StateForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      state: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.state = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.state = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.state = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
